import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white">
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Left Section */}
          <div>
            <h2 className="text-2xl font-bold mb-6 leading-tight">PEL Partner<br />Company</h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Belgium-based specialist in premium radiators and heating solutions. We supply high-quality European radiators for residential and commercial projects across Belgium and Europe.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-pinterest-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Middle Section */}
          <div className="grid grid-cols-1 gap-6">
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">Belgium Office</p>
              <p className="text-white text-sm">Leuvenselaan 467, Tienen 3300, Belgium</p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">UK Office</p>
              <p className="text-white text-sm">London, United Kingdom</p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">Phone</p>
              <p className="text-white text-sm">+32487261970</p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500 mb-2">Email</p>
              <p className="text-white text-sm">pelpartnercompany@gmail.com</p>
            </div>
          </div>

          {/* Right Section */}
          <div className="flex justify-end">
            <img
              src="https://public.readdy.ai/ai/img_res/0ef458074d1a86058d144eb78ab097a0.jpg"
              alt="Designer Radiator"
              className="w-[280px] h-[400px] object-cover rounded-lg"
            />
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2026 PEL Partner Company. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5">
              <i className="ri-mail-line"></i>
              Contact Us
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/request-quote" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5">
              <i className="ri-file-list-3-line"></i>
              Request a Quote
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/track-order" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5">
              <i className="ri-map-pin-time-line"></i>
              Track Order
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              Privacy
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              Terms
            </Link>
            <span className="text-gray-600">•</span>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
